export function toDate(value) {
  if (typeof value === 'string') {
    return new Date(value);
  }
  if (typeof value === 'number') {
    return new Date(value * 1000);
  }
  return value;
}